type Props = { text?: string; size?: number };

export default function Wordmark({ text = 'Goaround', size = 28 }: Props) {
  return (
    <span
      className="display"
      aria-label={`${text} logo`}
      style={{
        display: 'inline-flex',
        alignItems: 'baseline',
        fontSize: size,
        fontWeight: 800,
        letterSpacing: '-0.045em',
        color: 'var(--ink)',
        lineHeight: 1,
        whiteSpace: 'nowrap',
      }}
    >
      {text}
      <span aria-hidden="true" style={{ color: 'var(--primary)', marginLeft: '-0.02em' }}>
        .
      </span>
    </span>
  );
}
